module.exports = __webpack_public_path__ + "media/images/trailer-a980a25ddebdef62bc6be330c93e3819.svg";